import { ServiceDataSource } from '../cmc/service-datasource.model';
import { QuoteWrapper } from './quote-wrapper';

export class CmcQuote extends QuoteWrapper {
    constructor(
        public readonly cmcProtocolCode: string,
        public readonly cmcProtocolName: string,
        public readonly cmcProtocolComment: string,
        public readonly serviceDataSources: ServiceDataSource[],
        public readonly cmcUniqueReference: boolean
    )
        
    {
        super();
    }
}